import { getTouchEventCoordinates } from 'front-end-core/helpers/document'
import { TouchEnd, TouchMove } from 'front-end-core/services/WindowService'
import { getMinimumSwipeThreshold } from 'services/WindowService'
import { takeUntil, throttleTime, map, takeWhile } from 'rxjs/operators'

const useTouchStart = (handleSwipeLeft, handleSwipeRight) => {
  const handleTouchStart = (event) => {
    const windowWidth = document.body.clientWidth
    let { x, y } = getTouchEventCoordinates(event.nativeEvent)
    const abs = Math.abs
    let continueSwipe

    TouchMove
      .pipe(
        takeUntil(TouchEnd),
        throttleTime(10),
        map(getTouchEventCoordinates),
        takeWhile(coords => continueSwipe !== false && (abs(coords.y - y) < abs(coords.x - x) || abs(coords.y - y) < 20))
      )
      .subscribe(end => {
        const swiped = Math.floor((abs(end.x - x) / windowWidth) * 100)
        if (swiped >= getMinimumSwipeThreshold(windowWidth)) {
          if (end.x - x < 0 && typeof handleSwipeLeft === 'function') {
            continueSwipe = handleSwipeLeft()
          }
          if (end.x - x > 0 && typeof handleSwipeRight === 'function') {
            continueSwipe = handleSwipeRight()
          }
          x = end.x
          y = end.y
        }
      })
  }

  return { handleTouchStart }
}

export default useTouchStart
